import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useNavigate } from "react-router-dom";
import {
  changeCurrentFilteredRequest,
  getFilteredconsultations,
  selectCurrentConsultationsResult,
  selectCurrentFilterdConsultRequest,
  selectCurrentLoadingConsults,
  selectCurrentLoadingStartConsultation,
  setCurrentConsultationDetail,
  startConsultation,
} from "../listasSlice";
import PaginationItem from "../../../../helpers/PaginationItem";
import { usePagination } from "pagination-react-js";
import Modal, { Styles } from "react-modal";
import {
  ConsultationResultDetail,
  ConsultationResultItem,
  StartConsultationReq,
} from "../externalInfoAPI";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClipLoader } from "react-spinners";
import { selectRoles } from "../../../common/commonSlice";
import { delay, formatDateStandar } from "../../../../helpers/utils";
import { DropDown } from "../../../common/components/Btns/DropDown";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import es from "date-fns/locale/es";
import { format } from "date-fns";

Modal.setAppElement("#root");

const customStylesModalStart: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "75%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};

export const Consultations = () => {
  registerLocale("es", es as any);
  const currentConsultationsResult = useAppSelector(
    selectCurrentConsultationsResult
  );
  const currentFilteredRequest = useAppSelector(
    selectCurrentFilterdConsultRequest
  );
  const { page, pageSize } = currentFilteredRequest;
  let roles = useAppSelector(selectRoles);
  const loadingList = useAppSelector(selectCurrentLoadingConsults);
  const loadingStart = useAppSelector(selectCurrentLoadingStartConsultation);

  const [showStartConsultModal, setShowStartConsultModal] = useState(false);
  const [startConsultationData, setStartConsultationData] = useState<
    StartConsultationReq | undefined
  >();
  const [loadingStart2, setLoadingStart2] = useState(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const getStatusConsultationName = (status: string) => {
    switch (status) {
      case "started":
        return "En proceso";
      case "finished":
        return "Terminado";
      default:
        return "En proceso";
    }
  };

  const getConsultationIdentification = (
    consultation: ConsultationResultItem
  ) => {
    if (consultation.placa) {
      return consultation.placa;
    } else {
      return consultation.identification;
    }
  };

  const getConsultationIdentificationType = (
    consultation: ConsultationResultItem
  ) => {
    if (consultation.placa) {
      return "Placa";
    } else {
      switch (consultation.identificationType) {
        case "CC":
          return "Cédula de ciudadanía";
        case "CE":
          return "Cédula de extranjería";
        case "NIT":
          return "NIT";
        case "PP":
          return "Pasaporte";
        case "PPT":
          return "Permiso de permanencia";
        case "INT":
          return "Internacional";
        default:
          return "Cédula de ciudadanía";
      }
    }
  };

  const Pagination = () => {
    const { records, pageNumbers, setActivePage, setRecordsPerPage } =
      usePagination({
        activePage: page + 1,
        recordsPerPage: pageSize || 10,
        totalRecordsLength: currentConsultationsResult
          ? currentConsultationsResult.numPages * 10
          : 1,
        offset: 1,
        navCustomPageSteps: { prev: 5, next: 5 },
        permanentFirstNumber: true,
        permanentLastNumber: true,
      });

    function updateActivePage(pageNumber: number | false) {
      pageNumber &&
        dispatch(
          changeCurrentFilteredRequest({
            ...currentFilteredRequest,
            page: pageNumber - 1,
          })
        );
      pageNumber && setActivePage(pageNumber);
    }

    return (
      <div
        style={{
          width: "100%",
          marginTop: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            marginLeft: "3%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <select
            style={{
              width: "50px",
              height: "30px",
              background: "#0a2a39",
              color: "white",
              border: "none",
              borderRadius: "8px",
              marginRight: "5px",
            }}
            value={pageSize || 10}
            onChange={(e) => {
              dispatch(
                changeCurrentFilteredRequest({
                  ...currentFilteredRequest,
                  pageSize: parseInt(e.target.value),
                })
              );
              setRecordsPerPage(parseInt(e.target.value));
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
          <p style={{ fontSize: "13px", color: "white", margin: "0 0 0 3px " }}>
            Registros por página
          </p>
        </div>
        <nav role="navigation" aria-label="Paginación">
          <ul className="pagination">
            <PaginationItem
              label={`Goto first page ${pageNumbers.firstPage}`}
              onClick={() => updateActivePage(pageNumbers.firstPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&laquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto previous page ${pageNumbers.previousPage}`}
              onClick={() => updateActivePage(pageNumbers.previousPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&lsaquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto first page ${pageNumbers.firstPage}`}
              active={pageNumbers.firstPage === pageNumbers.activePage}
              onClick={() => updateActivePage(pageNumbers.firstPage)}
            >
              {pageNumbers.firstPage}
            </PaginationItem>

            {pageNumbers.customPreviousPage && (
              <PaginationItem
                label={`Goto page ${pageNumbers.customPreviousPage}`}
                onClick={() => updateActivePage(pageNumbers.customPreviousPage)}
              >
                &middot;&middot;&middot;
              </PaginationItem>
            )}

            {pageNumbers.navigation.map((navigationNumber) => {
              const isFirstOrLastPage =
                navigationNumber === pageNumbers.firstPage ||
                navigationNumber === pageNumbers.lastPage;

              return isFirstOrLastPage ? null : (
                <PaginationItem
                  label={`Goto page ${navigationNumber}`}
                  key={navigationNumber}
                  active={navigationNumber === pageNumbers.activePage}
                  onClick={() => updateActivePage(navigationNumber)}
                >
                  {navigationNumber}
                </PaginationItem>
              );
            })}

            {pageNumbers.customNextPage && (
              <PaginationItem
                label={`Goto page ${pageNumbers.customNextPage}`}
                onClick={() => updateActivePage(pageNumbers.customNextPage)}
              >
                &middot;&middot;&middot;
              </PaginationItem>
            )}

            {pageNumbers.firstPage !== pageNumbers.lastPage && (
              <PaginationItem
                label={`Goto last page ${pageNumbers.lastPage}`}
                active={pageNumbers.lastPage === pageNumbers.activePage}
                onClick={() => updateActivePage(pageNumbers.lastPage)}
              >
                {pageNumbers.lastPage}
              </PaginationItem>
            )}

            <PaginationItem
              label={`Goto next page ${pageNumbers.nextPage}`}
              onClick={() => updateActivePage(pageNumbers.nextPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&rsaquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto last page ${pageNumbers.lastPage}`}
              onClick={() => updateActivePage(pageNumbers.lastPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&raquo;</p>
            </PaginationItem>
          </ul>
        </nav>
        <div style={{ height: "10px", width: "10px" }}></div>
      </div>
    );
  };

  useEffect(() => {
    dispatch(setCurrentConsultationDetail(null));
    dispatch(getFilteredconsultations());
  }, [currentFilteredRequest]);
  return (
    <LoadingOverlay
      active={loadingList === "pending"}
      spinner={<ClipLoader color="white" size="150px" />}
    >
      <Modal
        isOpen={showStartConsultModal}
        style={customStylesModalStart}
        shouldCloseOnOverlayClick
        shouldReturnFocusAfterClose
        shouldFocusAfterRender
        onRequestClose={() => {
          setShowStartConsultModal(false);
          setStartConsultationData(undefined);
        }}
      >
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Crear consulta
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "10px 0 0 0",
            }}
          >
            {" "}
            <p
              style={{
                fontSize: "15px",
                color: "black",
                fontWeight: "500",
              }}
            >
              Ingrese la siguiente información para generar una consulta de
              fuentes de información
            </p>
          </div>
          <div
            style={{
              width: "100%",
              display: "grid",
              overflowY: "auto",
              overflowX: "hidden",
              alignContent: "start",
              gap: "10px",
              gridTemplateColumns: "1fr 1fr",
              minHeight: "350px",
            }}
          >
            <DropDown
              key={"Tipo de consulta"}
              title="Tipo de consulta"
              isClearable={false}
              useFirstOptionAsDefault
              titleColor="black"
              height="60px"
              options={[
                { label: "Persona o empresa", value: "PERSON" },
                { label: "Vehículo", value: "VEHICLE" },
              ]}
              onChange={(e) => {
                if (e && e.value) {
                  const value = e.value as "PERSON" | "VEHICLE";
                  switch (value) {
                    case "PERSON":
                      setStartConsultationData({
                        ...startConsultationData,
                        type: "PERSON",
                        identification: "",
                        identificationType: "CC",
                        placa: undefined,
                      });
                      break;
                    case "VEHICLE":
                      setStartConsultationData({
                        ...startConsultationData,
                        type: "VEHICLE",
                        identification: "",
                        placa: "",
                        identificationType: "CC",
                        name: undefined,
                        fechaExpedicion: undefined,
                        international: undefined,
                      });
                      break;
                  }
                }
              }}
              maxContent
            />
            {startConsultationData &&
              startConsultationData.type === "PERSON" && (
                <label
                  htmlFor="identification"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    No. de Identificación
                  </p>
                  <input
                    onChange={(e) => {
                      setStartConsultationData({
                        ...startConsultationData,
                        identification: e.target.value,
                      });
                    }}
                    id="identification"
                    name="identification"
                    type="text"
                    placeholder={
                      startConsultationData.identificationType === "NIT"
                        ? "Ej. 90000000 (sin codigo de verificación)"
                        : "Ej. 12345678"
                    }
                    value={
                      (startConsultationData &&
                        startConsultationData.identification) ||
                      ""
                    }
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                </label>
              )}
            {startConsultationData &&
              startConsultationData.type === "VEHICLE" && (
                <label
                  htmlFor="placa"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Placa
                  </p>
                  <input
                    onChange={(e) => {
                      setStartConsultationData({
                        ...startConsultationData,
                        placa: e.target.value,
                      });
                    }}
                    id="placa"
                    name="placa"
                    type="text"
                    placeholder="Ej. RCA123"
                    value={
                      (startConsultationData && startConsultationData.placa) ||
                      ""
                    }
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                </label>
              )}

            {startConsultationData &&
              startConsultationData.type === "PERSON" && (
                <DropDown
                  key={"Tipo de identificación"}
                  title="Tipo de identificación"
                  isClearable={false}
                  useFirstOptionAsDefault
                  titleColor="black"
                  maxMenuHeight={200}
                  height="60px"
                  options={[
                    { label: "Cedula de ciudadanía", value: "CC" },
                    { label: "Cedula de extranjería", value: "CE" },
                    { label: "Pasaporte", value: "PP" },
                    { label: "Permiso de permanencia", value: "PPT" },
                    { label: "NIT", value: "NIT" },
                  ]}
                  onChange={(e) => {
                    if (e && e.value) {
                      setStartConsultationData({
                        ...startConsultationData,
                        fechaExpedicion:
                          e.value !== "CC"
                            ? startConsultationData.fechaExpedicion
                            : undefined,
                        identificationType: e.value as
                          | "CC"
                          | "CE"
                          | "PP"
                          | "PPT"
                          | "NIT",
                      });
                    }
                  }}
                  maxContent
                />
              )}
            {startConsultationData &&
              startConsultationData.type === "VEHICLE" && (
                <DropDown
                  key={"Tipo de identificación Propietario"}
                  title="Tipo de identificación Propietario"
                  isClearable={false}
                  maxMenuHeight={200}
                  useFirstOptionAsDefault
                  titleColor="black"
                  height="60px"
                  options={[
                    { label: "Cedula de ciudadanía", value: "CC" },
                    { label: "Cedula de extranjería", value: "CE" },
                    { label: "Pasaporte", value: "PP" },
                    { label: "Permiso de permanencia", value: "PPT" },
                    { label: "NIT", value: "NIT" },
                  ]}
                  onChange={(e) => {
                    if (e && e.value) {
                      setStartConsultationData({
                        ...startConsultationData,
                        identificationType: e.value as
                          | "CC"
                          | "CE"
                          | "PP"
                          | "PPT"
                          | "NIT",
                      });
                    }
                  }}
                  maxContent
                />
              )}
            {startConsultationData &&
              startConsultationData.type === "VEHICLE" && (
                <label
                  htmlFor="identificationPropietario"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    No. de Identificación propietario
                  </p>
                  <input
                    onChange={(e) => {
                      setStartConsultationData({
                        ...startConsultationData,
                        identification: e.target.value,
                      });
                    }}
                    id="identificationPropietario"
                    name="identificationPropietario"
                    type="text"
                    placeholder={
                      startConsultationData.identificationType === "NIT"
                        ? "Ej. 90000000 (sin codigo de verificación)"
                        : "Ej. 12345678"
                    }
                    value={
                      (startConsultationData &&
                        startConsultationData.identification) ||
                      ""
                    }
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                </label>
              )}
            {startConsultationData &&
              startConsultationData.type === "PERSON" &&
              !startConsultationData.international && (
                <label
                  htmlFor="nombre"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    {startConsultationData.identificationType === "NIT"
                      ? "Razón social"
                      : "Nombre"}
                  </p>
                  <input
                    onChange={(e) => {
                      setStartConsultationData({
                        ...startConsultationData,
                        name: e.target.value ? e.target.value : undefined,
                      });
                    }}
                    id="nombre"
                    name="nombre"
                    type="text"
                    placeholder={
                      startConsultationData.identificationType === "NIT"
                        ? "Ej. Empresa S.A.S (opcional)"
                        : "Ej. Juan Perez (opcional)"
                    }
                    value={
                      (startConsultationData && startConsultationData.name) ||
                      ""
                    }
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                </label>
              )}
            {startConsultationData &&
              startConsultationData.type === "PERSON" &&
              startConsultationData.international === true && (
                <label
                  htmlFor="nombre"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    {startConsultationData.identificationType === "NIT"
                      ? "Razón social"
                      : "Nombre"}
                  </p>
                  <input
                    onChange={(e) => {
                      setStartConsultationData({
                        ...startConsultationData,
                        name: e.target.value ? e.target.value : undefined,
                      });
                    }}
                    id="nombre"
                    name="nombre"
                    type="text"
                    placeholder={
                      startConsultationData.identificationType === "NIT"
                        ? "Ej. Empresa S.A.S"
                        : "Ej. Juan Perez"
                    }
                    value={
                      (startConsultationData && startConsultationData.name) ||
                      ""
                    }
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                </label>
              )}
            {startConsultationData &&
              startConsultationData.type === "PERSON" &&
              startConsultationData.identificationType === "CC" && (
                <div
                  style={{
                    width: "75%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "5px",
                  }}
                >
                  <ReactDatePicker
                    locale="es"
                    selected={
                      startConsultationData?.fechaExpedicion
                        ? new Date(startConsultationData?.fechaExpedicion)
                        : null
                    }
                    isClearable
                    onChange={(date) => {
                      if (date) {
                        setStartConsultationData({
                          ...startConsultationData,
                          fechaExpedicion: date.toISOString(),
                        });
                      } else {
                        setStartConsultationData({
                          ...startConsultationData,
                          fechaExpedicion: undefined,
                        });
                      }
                    }}
                    placeholderText="Fecha de expedición Cedula (opcional)"
                    customInput={
                      <input
                        disabled={true}
                        id="name"
                        name="name"
                        type="text"
                        value={
                          startConsultationData?.fechaExpedicion
                            ? format(
                                new Date(startConsultationData.fechaExpedicion),
                                "dd/MM/yyyy"
                              )
                            : ""
                        }
                        style={{
                          border: "1px solid rgba(0,0,0,0.5)",
                          borderRadius: "6px",
                          background: "transparent",
                          padding: "7px 0px 7px 0px",
                          minHeight: "24px",
                          fontSize: "14px",
                          fontWeight: "600",
                          textAlign: "center",
                          color: "#000",
                          width: "100%",
                          cursor: "pointer",
                          alignSelf: "center",
                        }}
                      />
                    }
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date("1900-01-01")}
                    maxDate={new Date()}
                  />
                </div>
              )}
            {startConsultationData &&
              startConsultationData.type === "PERSON" && (
                <FormControlLabel
                  style={{
                    color: "#000",
                    width: "90%",
                    margin: "5px 0 5px 0px",
                    fontFamily: "Open Sans",
                  }}
                  control={
                    <Checkbox
                      style={{ color: "#000", alignSelf: "start" }}
                      checked={
                        startConsultationData &&
                        startConsultationData.international
                      }
                      onChange={() => {
                        if (startConsultationData.international) {
                          setStartConsultationData({
                            ...startConsultationData,
                            international: false,
                            identificationType: "CC",
                          });
                        } else {
                          setStartConsultationData({
                            ...startConsultationData,
                            international: true,
                            name: startConsultationData.name
                              ? startConsultationData.name
                              : "",
                          });
                        }
                      }}
                    />
                  }
                  label={
                    <span
                      style={{
                        fontFamily: "Open Sans",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#000",
                      }}
                    >
                      ¿Realizar consulta internacional?
                      <br />
                      (Se ignora el tipo de identificación y se consulta en
                      conjunto con el nombre)
                    </span>
                  }
                />
              )}
          </div>
          <div
            className="flex-row"
            style={{
              width: "90%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowStartConsultModal(false);
                setStartConsultationData(undefined);
              }}
              className="flex-col text-medium text-bold"
              style={{
                background: "transparent",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "1px solid #1A617D",
                color: "#1A617D",
              }}
            >
              Cancelar
            </button>
            <button
              disabled={false}
              onClick={(e) => {
                e.preventDefault();
                dispatch(startConsultation(startConsultationData!)).then(
                  async (x) => {
                    if (x.meta.requestStatus === "fulfilled") {
                      setStartConsultationData(undefined);
                      const result = x.payload as ConsultationResultDetail;
                      setLoadingStart2(true);
                      await delay(5000);
                      setShowStartConsultModal(false);
                      setLoadingStart2(false);
                    }
                  }
                );
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              {loadingStart === "pending" || loadingStart2 ? (
                <ClipLoader color="white" size={"20px"} />
              ) : (
                "Consultar"
              )}
            </button>
          </div>
        </div>
      </Modal>
      {currentConsultationsResult &&
      currentConsultationsResult.consultations.length > 0 ? (
        <div className="flex-col" style={{ width: "100%", height: "100%" }}>
          <div
            className="flex-row"
            style={{
              height: "10%",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <div
              className="text-xx-large text-bold primary-color"
              style={{ marginRight: "2%" }}
            >
              Consultas Realizadas
            </div>
          </div>
          <div
            className="text-medium text-bold primary-color"
            style={{
              marginTop: "5px",
              marginRight: "2%",
              marginLeft: "1%",
              marginBottom: "2%",
              background: "rgba(0,0,0,0.4)",
              paddingRight: "30px",
              paddingTop: "10px",
              paddingBottom: "10px",
              paddingLeft: "30px",
              borderRadius: "8px",
              textAlign: "center",
              cursor: "pointer",
              width: "180px",
              visibility: roles.includes("lists.consult")
                ? "visible"
                : "collapse",
            }}
            onClick={(e) => {
              e.preventDefault();
              setShowStartConsultModal(true);
              setStartConsultationData({
                identificationType: "CC",
                type: "PERSON",
              });
            }}
          >
            Realizar nueva consulta
          </div>
          {currentConsultationsResult.consultations ? (
            <div className="flex-col" style={{ height: "70%" }}>
              <div style={{ overflow: "auto" }}>
                <table
                  style={{
                    width: "98%",
                    borderCollapse: "collapse",
                    marginLeft: "1%",
                  }}
                >
                  <thead
                    className="text-normal text-medium primary-color-35"
                    style={{
                      background: "rgba(0,0,0,0.4)",
                      height: "30px",
                      textAlign: "center",
                    }}
                  >
                    <tr>
                      <th></th>
                      <th>Id consulta</th>
                      <th>Identificación</th>
                      <th>Tipo de Identificación</th>
                      <th>Fecha de Consulta</th>
                      <th>Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody
                    className="text-normal text-x-small primary-color"
                    style={{
                      background: "rgba(0,0,0,0.2)",
                      textAlign: "center",
                    }}
                  >
                    <tr>
                      <td>&nbsp;</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    {currentConsultationsResult.consultations.map(
                      (consultation, i) => {
                        return (
                          <tr
                            key={`${i}${consultation.id}`}
                            className="list-hover"
                            style={{ height: "30px", cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/services/manualLists/consultations/${consultation.id}`
                              );
                            }}
                          >
                            <td></td>
                            <td>{consultation.id}</td>
                            <td>
                              {getConsultationIdentification(consultation)}
                            </td>
                            <td>
                              {getConsultationIdentificationType(consultation)}
                            </td>

                            <td>{formatDateStandar(consultation.createdAt)}</td>
                            <td>
                              {getStatusConsultationName(consultation.status)}
                            </td>
                            <td></td>
                          </tr>
                        );
                      }
                    )}
                    <tr>
                      <td>&nbsp;</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="flex-col" style={{ height: "70%" }}>
              <h1 className="text-huge text-bold primary-color">
                {loadingList === "pending"
                  ? ""
                  : "No hay consultas en esta página"}
              </h1>
            </div>
          )}
          <div
            className="flex-row"
            style={{
              justifyContent: "end",
              alignItems: "center",
              height: "10%",
            }}
          >
            <Pagination />
          </div>
        </div>
      ) : (
        <div
          className="flex-col"
          style={{
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="text-medium text-bold primary-color"
            style={{
              marginTop: "5px",
              marginRight: "2%",
              marginLeft: "1%",
              marginBottom: "2%",
              background: "rgba(0,0,0,0.4)",
              paddingRight: "30px",
              paddingTop: "10px",
              paddingBottom: "10px",
              paddingLeft: "30px",
              borderRadius: "8px",
              textAlign: "center",
              cursor: "pointer",
              width: "180px",
              visibility: roles.includes("lists.consult")
                ? "visible"
                : "collapse",
            }}
            onClick={(e) => {
              e.preventDefault();
              setShowStartConsultModal(true);
              setStartConsultationData({
                identificationType: "CC",
                type: "PERSON",
              });
            }}
          >
            Realizar nueva consulta
          </div>
          <h1 className="text-huge text-bold primary-color">
            {loadingList === "pending" ? "" : "No hay consultas en esta página"}
          </h1>
        </div>
      )}
    </LoadingOverlay>
  );
};
